export const EU = 'eu';
export const EU_COLOR = 'eu-color';
export const WORLD = 'world';

// TODO add the rest
